import { joinSgcmMedia, joinSgcmSite } from '@/utils/url/join/public';

export const featuredMerchantsAds = (isDesktop: boolean) => [
  {
    title: 'Professional & Hassle-Free Vehicle Inspection',
    img: `${joinSgcmMedia('/public/new-cars/sta.jpeg')}`,
    link: isDesktop
      ? `${joinSgcmSite('/directory/vehicle_inspection.php')}`
      : `${joinSgcmSite('/directory/vehicle_inspection.php')}`,
  },
  {
    title: 'The largest car plate number specialist in Singapore',
    img: `${joinSgcmMedia('/public/ads/banners/eurospeed_banner.jpg')}`,
    link: isDesktop
      ? `${joinSgcmSite('/directory/carplate_eurospeed.php')}`
      : `${joinSgcmSite('/directory/carplate_eurospeed.php')}`,
  },
];
